export interface DataErrorMessage {
	error: DataErrorMessageEnum;
	message?: string;
	parameters?: any;
}

export enum DataErrorMessageEnum {
	BENCHMARK_NOT_ALLOWED = 'BENCHMARK_NOT_ALLOWED',
	LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
	UNKNOWN = 'UNKNOWN',
	MISSING_MODULE = 'MISSING_MODULE',
	MISSING_ROLE = 'MISSING_ROLE',
	NO_ACCESS = 'NO_ACCESS',
	QUERY_TIMEOUT = 'QUERY_TIMEOUT',
	UNEXPECTED = 'UNEXPECTED',
	INTERRUPTED = 'INTERRUPTED',
}
